import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse, HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from "./_services/auth_service";
import { RedirectService } from "./_services/redirect_service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService, private redirect: RedirectService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const language = localStorage.getItem('lang') || 'it';
    const modifiedReq = req.clone({
          setHeaders: {
              'Accept-Language': language
          }
    });

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {

        // Cambio password richiesto
        if (error.status == 423) {
           this.router.navigate(['/forzacambiopassword']);
        }

        // Nuovi consensi
        if (error.status == 424) {
           this.router.navigate(['/prestaconsensi']);
        }

          // Double optin
          if (error.status == 428) {
              this.router.navigate(['/doubleoptin']);
          }


          // Unauthorized
        if (error.status === 401) {
          const isAuthCheck = req.url.endsWith('/user');
          this.authService.logout().subscribe({next: (response: HttpResponse<any>) => {}, error: (error) => {}});
          // La 401 sulla chiamata di auth-check (/user, usata dai guard e dalla
          // pagina di login) e' gia' gestita: dai guard con redirect a /login
          // e returnUrl=state.url, o dalla login stessa. L'interceptor NON deve
          // navigare in questo caso, altrimenti sovrascrive il returnUrl con un
          // redirect a /login "nudo" (race sul cold-open dei link email).
          // Per le altre 401 (chiamate dati) redirige solo se non c'e' gia' una
          // navigazione in corso gestita da un guard.
          if (!isAuthCheck && !this.router.getCurrentNavigation()) {
            // 401 a sessione gia' avviata: salva la pagina corrente (verra'
            // consumata all'atterraggio in dashboard) e vai a /login.
            const currentUrl = this.router.url;
            if (currentUrl && !currentUrl.startsWith('/login') && currentUrl !== '/') {
              this.redirect.save(currentUrl);
            }
            this.router.navigate(['/login']);
          }
        }
        return throwError(() => error); // Propaga l'errore
      })
    );
  }
}
